import { Solucoes } from "./style";
import Risco from "../../../../assets/risco.svg"


function SolucoesComponent() {
  return (
    <Solucoes>
      <div id="description">
        <div id="desc-one">
          <span>relaxa, eu tenho a solução!</span>
          <h1>Não ficou feliz com suas respostas?</h1>
          <img src={Risco} alt="" />
          <br/>
          <span id="olhada-desktop">Dê uma olhada no que você terá acesso abaixo 👇🏼</span>
        </div>
        <div id="desc-two">
            <p id="bold-desc-two">Calma, você precisa conhecer a oportunidade que preparei para você!</p>
            <p id="paragraph-desc-two">A grande maioria das pessoas  quer falar inglês mas não chegam ao resultado que precisam e, principalmente, no tempo que precisam para suas necessidades pessoais ou de sua carreira. Você pode ir muito além: Viajar tranquilamente, conhecer novas culturas, conquistar o trabalho dos sonhos até em outro país, entre outras várias opções.</p>
            <span id="olhada-mobile">Dê uma olhada no que você terá acesso abaixo 👇🏼</span>
        </div>
      </div>
      <div id="solutions">
        <button className="buttons"><p>Imersão no idioma de forma gradual e controlada</p></button>
        <button className="buttons"><p>plataforma online</p></button>
        <button className="buttons"><p>Acompanhamento de desempenho</p></button>
        <button className="buttons"><p>mentoria para otimização de resultados (técnicas e dicas)</p></button>
        <button className="buttons"><p>exposição ao idioma nas 4 habilidades (fala, escrita, audição e leitura)</p></button>
        <button className="buttons"><p>Contato diário com o idioma através de interações e atividades</p></button>
      </div>
    </Solucoes>
  );
}

export default SolucoesComponent;
